module.exports = __webpack_public_path__ + "img/one.dded6595.png";